import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';

const getTodayDate = () => {
    return new Date().toISOString().split('T')[0]; // Результат: "2026-01-21"
};

const initData = {
    product_id: '',
    planned_quantity: '',
    order_number: '',
    planned_start_date: getTodayDate(), // Установит сегодня по умолчанию
    planned_end_date: getTodayDate(),
    comment: '',
};

function AcceptanceMaterials({ modal, setModal, getData }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData })

    const [products, setProducts] = useState([])
    // const [units, setUnits] = useState([])

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST('/production/orders/', sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData })
            getData()
        }
    }
    const handleDateChange = (date, fieldName) => {
        const formattedDate = date ? date.toISOString().split('T')[0] : '';

        setSendData(prev => ({
            ...prev,
            [fieldName]: formattedDate
        }));
    };

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }


    useEffect(() => {
        async function getRawMaterials() {
            const response = await GET('/catalogs/products/')
            if (httpOk(response)) {
                setProducts(response.data)
            }
        }

        getRawMaterials()
    }, []);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('create_production_order')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('select_product_and_volume_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('product_sku')}</label>
                        <CustomSelect
                            options={products}
                            value={products?.find(option => option.id === sendData?.product_id) || ''}
                            onChange={(option) => setSendData({ ...sendData, product_id: option.id, unit_id: option.unit_id })}
                            placeholder={t('select_product')}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('order_number')}</label>
                        <input type="text" placeholder="" name="order_number"
                            value={sendData.order_number} onChange={(e) => handleChange(e)} />
                    </div>
                    <div className="form-group">
                        <label>{t('planned_volume')}</label>
                        <input type="text" placeholder="0" name="planned_quantity"
                            value={sendData.planned_quantity} onChange={(e) => handleChange(e)} />
                    </div>
                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('comment')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>
                    <div className="grid2 gap-16">
                        <div className="form-group">
                            <label>{t('start_date')}</label>
                            <DatePicker
                                portalId="root"
                                selected={sendData.planned_start_date ? new Date(sendData.planned_start_date) : null}
                                onChange={(date) => handleDateChange(date, 'planned_start_date')}
                                dateFormat="yyyy-MM-dd"
                                placeholderText={t('select_date')}
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('end_date')}</label>
                            <DatePicker
                                portalId="root"
                                selected={sendData.planned_end_date ? new Date(sendData.planned_end_date) : null}
                                onChange={(date) => handleDateChange(date, 'planned_end_date')}
                                dateFormat="yyyy-MM-dd"
                                placeholderText={t('select_date')}
                            />
                        </div>
                    </div>

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('create_order')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default AcceptanceMaterials